import { createSlice } from '@reduxjs/toolkit'

const WebinarSlice = createSlice({
    name: "Webinar",
    initialState: {
        Webinars: [],
        currentWebinar: {
            title: '',
            content: '',
            banner: '',
            author: '',
            publishDate: '',
            isDraft: true
        },
        isLoading: false,
        error: null,
        isSaving: false
    },
    reducers: {
        // Create/Save Webinar actions
        saveWebinarStart: (state) => {
            state.isSaving = true
        },
        saveWebinarSuccess: (state, action) => {
            state.isSaving = false
            state.currentWebinar = action.payload
            state.error = null
        },
        saveWebinarFailure: (state, action) => {
            state.isSaving = false
            state.error = action.payload
        },

        // Fetch Webinars actions
        fetchWebinarsStart: (state) => {
            state.isLoading = true
        },
        fetchWebinarsSuccess: (state, action) => {
            state.isLoading = false
            state.Webinars = action.payload
            state.error = null
        },
        fetchWebinarsFailure: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },

        // Update current Webinar
        updateCurrentWebinar: (state, action) => {
            state.currentWebinar = {
                ...state.currentWebinar,
                ...action.payload
            }
        },

        // Clear current Webinar
        clearCurrentWebinar: (state) => {
            state.currentWebinar = {
                title: '',
                content: '',
                banner: '',
                author: '',
                publishDate: '',
                isDraft: true
            }
        }
    }
})

export const {
    saveWebinarStart,
    saveWebinarSuccess,
    saveWebinarFailure,
    fetchWebinarsStart,
    fetchWebinarsSuccess,
    fetchWebinarsFailure,
    updateCurrentWebinar,
    clearCurrentWebinar
} = WebinarSlice.actions

export default WebinarSlice.reducer